import axios from "axios";
import { saveBlob, getBlob } from "./offline";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Globally redirect to /pricing when the backend reports the trial/subscription has expired.
api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    if (err?.response?.status === 402) {
      const path = window.location.pathname;
      if (path !== "/pricing" && path !== "/payment/success") {
        window.location.assign("/pricing");
      }
    }
    return Promise.reject(err);
  },
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export async function downloadFile(fileId, filename) {
  // Try network first; cache blob for future offline downloads.
  try {
    const res = await api.get(`/files/${fileId}/download`, { responseType: "blob" });
    const blob = new Blob([res.data]);
    triggerDownload(blob, filename);
    saveBlob(fileId, blob, filename, blob.type).catch(() => {});
    return;
  } catch (err) {
    // Fallback: serve from IndexedDB cache if we have it
    const cached = await getBlob(fileId);
    if (cached?.blob) {
      triggerDownload(cached.blob, cached.filename || filename);
      return;
    }
    throw err;
  }
}
